import React, { useRef, useState, useEffect } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import './QR.css';
import { AiOutlineScan } from 'react-icons/ai';

const MobileQRScanner = ({ onScanSuccess }) => {
  const qrRef = useRef(null);
  const html5QrCode = useRef(null);
  const [isScanning, setIsScanning] = useState(false);
  const [error, setError] = useState('');
  const [showScanner, setShowScanner] = useState(false);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const handleStartClick = () => {
    setError('');
    setShowScanner(true);
  };

  useEffect(() => {
    const startScanner = async () => {
      if (!qrRef.current || isScanning) return;

      html5QrCode.current = new Html5Qrcode('html5qr-reader');
      try {
        await html5QrCode.current.start(
          { facingMode: 'environment' },
          { fps: 10, qrbox: 250 },
          (decodedText) => {
            try {
              onScanSuccess(decodedText);
              stopScanner();
            } catch (err) {
              console.warn('Invalid QR code scanned:', err);
              setError('Invalid QR code scanned. Please try again.');
            }
          },
          () => {},
        );
        setIsScanning(true);
      } catch (err) {
        setError('Camera access failed or not supported.');
        console.error('QR Scan error:', err);
      }
    };

    if (showScanner && !isScanning) {
      startScanner();
    }
  }, [showScanner]); // Re-run when showScanner changes

  const stopScanner = async () => {
    if (html5QrCode.current) {
      try {
        await html5QrCode.current.stop();
        await html5QrCode.current.clear();
      } catch (err) {
        console.error('Error stopping scanner:', err);
      } finally {
        setIsScanning(false);
        setShowScanner(false);
      }
    }
  };

  if (!isMobile) return null;

  return (
    <div className="qr-container">
      {!isScanning && (
        <button type="button" className="qr-button" onClick={handleStartClick}>
          <AiOutlineScan />
          Start Scanning
        </button>
      )}

      {showScanner && <div id="html5qr-reader" ref={qrRef} className="qr-reader" />}

      {error && <p className="qr-error">{error}</p>}

      {isScanning && (
        <button className="qr-stop-button" onClick={stopScanner}>
          Stop Scanning
        </button>
      )}
    </div>
  );
};

export default MobileQRScanner;
